export let balanceManageTableLabels = [
  {
    label: '事业部',
    value: 'departmentName'
  },
  {
    label: '操作类型',
    value: 'changeOperationType'
  },
  {
    label: '金额（元）',
    value: 'balance_show'
  },
  {
    label: '内容/原因',
    value: 'content_show'
  },
  {
    label: '财务用户',
    value: 'operatorName'
  },
  {
    label: '操作时间',
    value: 'operate_time'
  }
]
export let filterLabels = [
  {
    label: '事业部',
    type: 'select',
    value: 'departmentId',
    clearable: true,
    options: []
  },
  {
    label: '时间区间',
    type: 'time-slot',
    startName: 'startDate', // 返回数据时，开始时间的字段名
    endName: 'endDate', // 返回数据时，结束时间的字段名
    value: 'operateTime'
  },
  {
    label: '操作类型',
    type: 'select',
    value: 'operationType',
    clearable: true,
    options: [
      {
        label: '增加',
        value: 'INCREASE'
      },
      {
        label: '减少',
        value: 'DECREASE'
      }
    ]
  }
]
